module.exports = "pegasus_template/assets/blocks/tile-layout-06.png";